var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRamLimiterEnabledMain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RAM Limiter",
    clipPath: "url(#clip0_40_3339)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5357 41.2143H51.6786V43.3571H55.9643V17.6429H4.53571V43.3571H34.5357V41.2143ZM0.25 13.3571V47.6429H38.8214V45.5H47.3929V47.6429H60.25V13.3571H0.25Z",
    fill: "#BCB3D0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.82143 43.3571L8.82143 30.5H13.1071V43.3571H8.82143Z",
    fill: "#BCB3D0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3929 43.3571V30.5H21.6786V43.3571H17.3929Z",
    fill: "#BCB3D0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9643 43.3571V30.5H30.25V43.3571H25.9643Z",
    fill: "#BCB3D0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.25 30.5L38.8214 30.5V34.7857L0.25 34.7857L0.25 30.5Z",
    fill: "#BCB3D0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.3929 30.5H60.25V34.7857L47.3929 34.7857V30.5Z",
    fill: "#BCB3D0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5357 43.3571V30.5L38.8214 30.5V43.3571H34.5357Z",
    fill: "#BCB3D0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.3929 43.3571V30.5H51.6786V43.3571H47.3929Z",
    fill: "#BCB3D0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40_3339"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(0.25 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRamLimiterEnabledMain);
export default __webpack_public_path__ + "static/media/ramLimiterEnabledMain.8ca53512d2049dc6bb1b4fc3fe480243.svg";
export { ForwardRef as ReactComponent };